import React from 'react';

const LegalDisclaimer = ({ type = "basic" }) => {
  if (type === "homepage") {
    return (
      <div className="bg-gray-50 border-t border-gray-200 py-8 px-4 mt-16">
        <div className="max-w-4xl mx-auto text-center">
          <h3 className="font-semibold text-lg mb-4">Disclaimer</h3>
          <p className="text-sm text-gray-700 mb-4">
            BBC QuickList is an advertising and training platform. We are not a franchise or 
            multi-level marketing company, and no earnings are guaranteed. Results vary and depend 
            on individual effort, market conditions, and use of our tools.
          </p>
          <p className="text-sm text-gray-600">
            See our{" "}
            <a 
              href="/income-disclosure-statement.pdf" 
              className="text-blue-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Income Disclosure Statement
            </a>
            {" "}for details.
          </p>
        </div>
      </div>
    );
  }

  if (type === "footer") {
    return (
      <div className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-6xl mx-auto">
          <h3 className="font-semibold text-lg mb-4 text-center">Important Disclaimers</h3>
          
          <div className="text-sm space-y-4 mb-6">
            <p>
              <strong>BBC QuickList is an advertising and training platform.</strong> We provide ad credits, 
              tools, and resources that can be used for marketing purposes or resold through our 
              peer-to-peer referral system.
            </p>
            
            <p>
              We are <strong>not a franchise, multi-level marketing company, or "get rich quick" program</strong>. 
              Members are compensated through direct member-to-member payments when products 
              (credits, tools, or services) are purchased.
            </p>
            
            <p>
              Your results will vary and depend on many factors including effort, experience, and 
              market conditions. <strong>No earnings are guaranteed.</strong> Advertising always involves 
              risk and requires ongoing effort.
            </p>
            
            <p>
              This site is not affiliated with or endorsed by Facebook™, Google™, or any third-party 
              platforms mentioned.
            </p>
          </div>
          
          <div className="border-t border-gray-700 pt-4 text-center text-xs text-gray-400">
            <p>© 2025 BBC QuickList – All Rights Reserved.</p>
            <div className="mt-2 space-x-4">
              <a 
                href="/income-disclosure-statement.pdf" 
                className="hover:text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                Income Disclosure Statement
              </a>
              <span>•</span>
              <a href="/faq" className="hover:text-white">FAQ</a>
              <span>•</span>
              <a href="/legal" className="hover:text-white">Legal</a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "compensation") {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 my-8">
        <h3 className="font-bold text-xl mb-4 flex items-center">
          <span className="text-yellow-600 mr-2">⚠️</span>
          Earnings & Participation Disclaimer
        </h3>
        
        <div className="space-y-4 text-sm">
          <p>
            <strong>BBC QuickList uses a tiered product model</strong> (1×2, 2×3, and 12×3) to represent 
            different product and service levels. Each level corresponds to specific ad credit packages and/or tools.
          </p>
          
          <p>
            <strong>Members do not receive percentage overrides or multi-level payouts.</strong> Instead, 
            each purchase is paid 100% directly, member-to-member, for the product at that level.
          </p>
          
          <p>
            <strong>Participation is optional</strong> and begins with a Pay-It-Forward (PIF) voucher system, 
            which allows new users to test the platform before making any purchase decision.
          </p>
          
          <div className="bg-white p-4 rounded border-l-4 border-blue-500">
            <p className="font-semibold mb-2">We encourage every participant to make informed decisions.</p>
            <p>
              Take time to review the information, consider your financial situation, and consult 
              with trusted advisors if necessary.
            </p>
          </div>
          
          <p>
            <strong>Past performance or examples do not guarantee future results.</strong> Earnings vary 
            and are based on individual effort, use of tools, and market conditions.
          </p>
          
          <p className="bg-blue-50 p-3 rounded">
            <strong>BBC QuickList is a direct sales and advertising platform</strong>, not a business 
            opportunity under FTC § 437.1m and not a franchise under the FTC Franchise Rule.
          </p>
        </div>
      </div>
    );
  }

  if (type === "plain") {
    return (
      <div className="bg-gray-100 p-4 rounded-lg text-center">
        <p className="text-sm font-medium">
          <strong>Disclaimer:</strong> "No guarantees. Your results depend on your own effort and 
          market conditions. BBC QuickList provides advertising credits and tools, not promises of income."
        </p>
      </div>
    );
  }

  // Basic disclaimer (default)
  return (
    <div className="text-xs text-gray-500 mt-4">
      <p>
        <strong>Disclaimer:</strong> Results not guaranteed. Individual results vary based on effort 
        and market conditions. BBC QuickList provides tools and training, not income promises.
      </p>
    </div>
  );
};

export default LegalDisclaimer;